/*!
 * @pixi/filter-color-replace - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-color-replace is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import { Filter as i, utils as e } from "@pixi/core";
var t = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`,
  l = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec3 originalColor;
uniform vec3 newColor;
uniform float epsilon;
void main(void) {
    vec4 currentColor = texture2D(uSampler, vTextureCoord);
    vec3 colorDiff = originalColor - (currentColor.rgb / max(currentColor.a, 0.0000000001));
    float colorDistance = length(colorDiff);
    float doReplace = step(colorDistance, epsilon);
    gl_FragColor = vec4(mix(currentColor.rgb, (newColor + colorDiff) * currentColor.a, doReplace), currentColor.a);
}
`;
class s extends i {
  constructor(o = 16711680, r = 0, n = .4) {
    super(t, l), this._originalColor = 16711680, this._newColor = 0, this.uniforms.originalColor = new Float32Array(3), this.uniforms.newColor = new Float32Array(3), this.originalColor = o, this.newColor = r, this.epsilon = n;
  }
  set originalColor(o) {
    const r = this.uniforms.originalColor;
    typeof o == "number" ? (e.hex2rgb(o, r), this._originalColor = o) : (r[0] = o[0], r[1] = o[1], r[2] = o[2], this._originalColor = e.rgb2hex(r));
  }
  get originalColor() {
    return this._originalColor;
  }
  set newColor(o) {
    const r = this.uniforms.newColor;
    typeof o == "number" ? (e.hex2rgb(o, r), this._newColor = o) : (r[0] = o[0], r[1] = o[1], r[2] = o[2], this._newColor = e.rgb2hex(r));
  }
  get newColor() {
    return this._newColor;
  }
  set epsilon(o) {
    this.uniforms.epsilon = o;
  }
  get epsilon() {
    return this.uniforms.epsilon;
  }
}
export { s as ColorReplaceFilter };
